import styled from "styled-components";

import { colors } from "../../../../../../assets";

export const UnpaidInfoContainer = styled.section`
  line-height: 27px;

  p {
    margin-bottom: 20px;
  }

  p.list-title {
    margin-bottom: initial;
  }

  strong {
    font-weight: 700;
  }

  ul {
    list-style: revert;
    padding: revert;
    margin-bottom: 20px;

    li::marker {
      color: ${colors["PR-001-100"]};
    }
  }
`;
